/**
 * @generated SignedSource<<a42d7be203b2ed16af3c06fb3dc7dc94>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EventSummaryAttendees_org$data = {
  readonly id: string;
  readonly domains: ReadonlyArray<string>;
  readonly " $fragmentType": "EventSummaryAttendees_org";
};
export type EventSummaryAttendees_org$key = {
  readonly " $data"?: EventSummaryAttendees_org$data;
  readonly " $fragmentSpreads": FragmentRefs<"EventSummaryAttendees_org">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EventSummaryAttendees_org",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "domains",
      "storageKey": null
    }
  ],
  "type": "Org",
  "abstractKey": null
};

(node as any).hash = "4e804ccf432fffd600814c62f9bcaf8a";

export default node;
